/**
 * Fonction fetch personnalisée qui injecte automatiquement le token Keycloak
 */
import { getInstanceKeycloak } from './keycloakService';

export const apiFetch = async (url, options = {}) => {
    const keycloak = getInstanceKeycloak();

    // 1. Si on est connecté, on vérifie si le token expire bientôt (ex: < 30s)
    if (keycloak.authenticated) {
        try {
            await keycloak.updateToken(30);
        } catch (error) {
            console.error("Erreur de rafraîchissement du token, reconnexion...", error);
            keycloak.login();
        }
    }

    // 2. Préparation des en-têtes (headers)
    const headers = new Headers(options.headers || {});
    
    // On glisse le fameux badge (Token JWT) dans l'enveloppe
    if (keycloak.token) {
        headers.append('Authorization', `Bearer ${keycloak.token}`);
    }

    // 3. Construction de l'appel final
    const fetchOptions = {
        ...options,
        headers: headers
    };

    // Petit confort : si l'URL ne commence pas par http ou /api, on ajoute /api automatiquement
    const finalUrl = (url.startsWith('http') || url.startsWith('/api')) ? url : `/api${url}`;

    // 4. On lance le vrai fetch natif
    return fetch(finalUrl, fetchOptions);
};